module.exports = __webpack_public_path__ + "static/media/cover4.875f7db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover4.png
// module id = 557
// module chunks = 0